<div [@slideInOut]="active ? 'show' : 'hide'" class="legend-animate-container">
    <div class="no-legend-wrapper" >       
        {{ 'legendTxt.no-legend' | translate }}
    </div>
</div>